import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/policy-compliance')({
  beforeLoad: () => getTitleContextSlice('Policy Compliance'),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
